import Container from '@ahamove/web-components/lib/Container';
import Paper from '@ahamove/web-components/lib/Paper';
import Stack from '@ahamove/web-components/lib/Stack';
import Typography from '@ahamove/web-components/lib/Typography';
import cn from 'classnames';
import { useTranslation } from 'next-i18next';
import { useWebInAppStore } from '@/global-stores/useWebInAppStore';
import { homeConfig } from '@/modules/home/homeConfig';
import useIsMobile from '@/shared-hooks/useIsMobile';
import BookingBox from './BookingBox';
import { useNewBooking } from './NewBookingProvider';

export default function BookingSteps() {
  const { t } = useTranslation(homeConfig.i18nNamespaces);
  const { activeStep } = useNewBooking();
  const { isWebInApp } = useWebInAppStore();
  const bookingStep = activeStep === 0;
  const vehicleStep = activeStep === 1;
  const isMobile = useIsMobile();

  return (
    <Paper
      elevation={0}
      className={cn(
        'bg-hero-pattern-mobile desktop:bg-hero-pattern bg-cover bg-no-repeat',
        {
          // 'desktop:bg-home-banner-desktop': bookingStep,
          // 'desktop:bg-hero-pattern': vehicleStep,
        }
      )}
      sx={{
        backgroundPosition: 'top center',
        mb: isMobile && bookingStep ? 7 : 0,
      }}
    >
      <Container
        maxWidth="xl"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
        }}
        data-test-id="bookingStepContainer"
      >
        {/* <Stepper
          activeStep={activeStep}
          orientation="vertical"
          sx={{
            '.MuiStepConnector-root': { display: 'none' },
            '.MuiStepContent-root': { m: 0, p: 0, border: 'none' },
          }}
        >
          <Step>
            <StepContent> */}
        <Stack
          direction="column"
          pt={isMobile ? (isWebInApp ? 9 : 4) : vehicleStep ? 8 : 12}
          pb={7}
          mb={vehicleStep ? -14 : 0}
        >
          {bookingStep ? (
            <>
              <Typography
                mb={1.5}
                variant="h1"
                fontSize={isMobile ? 32 : 72}
                lineHeight={isMobile ? 1.25 : 1.1}
                maxWidth={935}
              >
                {t('booking:title')}
              </Typography>
              <Typography
                variant={isMobile ? 'body1' : 'h2'}
                fontWeight={500}
                mb={isMobile ? 4 : 8}
              >
                {t('booking:subtitle')}
              </Typography>
            </>
          ) : null}
          <BookingBox />
        </Stack>
        {/* </StepContent>
          </Step>
          <Step>
            <StepContent>EVSelection</StepContent>
          </Step>
        </Stepper> */}
      </Container>
    </Paper>
  );
}
